export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10894.31afb625.jpg";